<!-- @format -->

<ng-container *transloco="let t">
  @if (canApplyForModuleContentApproval()) {
    <h4 class="apply-for-mca-header">{{ t("MODULE_CONTENT_APPROVAL_INFO_MODAL.MODULE_CONTENT_APPROVAL_REQUEST_TITLE") }}</h4>
    @if (translationExists("MODULE_CONTENT_APPROVAL_HELP." + statusCode + ".DESCRIPTION")) {
      <div>{{ t("MODULE_CONTENT_APPROVAL_HELP." + statusCode + ".DESCRIPTION") }}</div>
    }
    @if (translationExists("MODULE_CONTENT_APPROVAL_HELP." + statusCode + ".INSTRUCTION")) {
      <sis-contextual-notification variant="danger">{{
        t("MODULE_CONTENT_APPROVAL_HELP." + statusCode + ".INSTRUCTION")
      }}</sis-contextual-notification>
    }
    <div class="float-end mca-buttons">
      @if (isFreeEdit && !isButtonHidden()) {
        <sis-button [size]="'sm'" [dataCy]="'request-approval-for-exceptions'" (clicked)="makeCustomModuleContentApplicationRequest()"
          >{{ t("FREE_EDIT.MAKE_MODULE_CONTENT_APPROVAL_REQUEST") }}
        </sis-button>
      }
      @if (!isFreeEdit && moduleContentApplicationRequired && !isButtonHidden()) {
        <sis-button [size]="'sm'" [dataCy]="'request-approval-for-module'" (clicked)="makeRequiredModuleContentApplicationRequest()"
          >{{ t("MODULE_CONTENT_APPROVAL_INFO_MODAL.MAKE_MODULE_CONTENT_APPROVAL_REQUEST") }}
        </sis-button>
      }
    </div>
    <div class="clearfix"></div>
  }
</ng-container>
